import React, { useEffect } from 'react';
import GeneralContext from '../contexts/GeneralContext';
import solutionsData from '../sharedData/SolutionsData';
import Introduction from '../components/Introduction';
import Footer from './Footer';

import Header from '../components/Header';
import CardContainer from '../components/CardContainer';
import { getCookie } from '../functions/Cookies';
import { navigateCookie } from '../sharedData/Constants';

import { useNavigate } from "react-router-dom";

const Study = () => {
    
    const navigate = useNavigate();

    useEffect(() => {
        if (!getCookie(navigateCookie)) {
            navigate("/");
        }
    });  

    return(
        <GeneralContext.Provider value={solutionsData}>
            <>
                <div>
                    <Header/>
                    <Introduction/>
                    <CardContainer/>
                    <Footer/>
                </div>
            </>
        </GeneralContext.Provider>
    );
};



export default Study;